import BaseService from "./_base.service";
import API from "../api";

import { AxiosResponse } from "axios";
import { Milestone } from "../models/milestone";
import { Commodity } from "../models/commodity";
import { ContainerSize } from "../models/container.size";
import { Waybill } from "../models/waybill";
interface ISubscriberPayload {
  firstName?: string;
  lastName?: string;
  contactType?: string;
  email?: string;
  mobile?: string;
  notifyViaEmail?: boolean;
  notifyViaSms?: boolean;
  shipmentId?: number;
  userId?: number | null;
  purchaseOrderId?: number;
}
const endpoint = "waybills";

const WaybillsService = {
  ...BaseService<Waybill>({ endpoint }),
  async getMilestoneDates(options?: any): Promise<AxiosResponse<Milestone[]>> {
    return await API.get(`/${endpoint}/milestones`, { params: options });
  },
  async getCommodities(options?: any): Promise<AxiosResponse<Commodity[]>> {
    return await API.get(`/${endpoint}/commodities`, { params: options });
  },
  async getContainerSizes(options?: any): Promise<AxiosResponse<ContainerSize[]>> {
    return await API.get(`${endpoint}/container/sizes`, { params: options });
  },
  async subscribe(id: number, waybill: Waybill): Promise<AxiosResponse<boolean>> {
    return await API.put(`${endpoint}/subscription/${id}`, waybill);
  },

  async addSubscriber(payload: any) {
    return await API.post("shipment/subscriber", payload);
  },

  async deleteSubscriber(subscriberId: number) {
    return await API.delete(`shipment/subscriber/${subscriberId}`);
  },

  async updateSubscriber(subscriberId: number, payload: any) {
    return await API.put(`shipment/subscriber/${subscriberId}`, payload);
  },
};


export default WaybillsService;
